import React, { useState, useContext } from "react"
import PropTypes from "prop-types"
import { Button, Form, Alert } from "react-bootstrap"
import SwaggerContext from "../SwaggerContext"
import { invitationService } from "../services/invitationService"

const SendInvitation = ({ onSuccess, onError }) => {
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState("")
  const [error, setError] = useState("")
  const swaggerClient = useContext(SwaggerContext)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setMessage("")
    setError("")

    try {
      if (!swaggerClient?.invitationApi) {
        throw new Error("API no disponible")
      }

      const result = await invitationService.sendInvitation(
        swaggerClient.invitationApi,
        email
      )

      if (result.success) {
        setMessage(`Invitación enviada a ${email}`)
        setEmail("")

        if (onSuccess) {
          onSuccess()
        }
      } else {
        const errorMsg = result.error || "Error desconocido"
        setError(errorMsg)

        if (onError) {
          onError(errorMsg)
        }
      }
    } catch (err) {
      const errorMsg = err instanceof Error ? err.message : "Error desconocido"
      setError(errorMsg)

      if (onError) {
        onError(errorMsg)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="send-invitation-form mb-4">
      <h3 className="mb-3">Invitar a un Paciente</h3>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label htmlFor="email">Email del Paciente:</Form.Label>
          <Form.Control
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="paciente@ejemplo.com"
            required
            disabled={loading}
          />
        </Form.Group>

        <Button variant="primary" type="submit" disabled={loading}>
          {loading ? "Enviando..." : "Enviar Invitación"}
        </Button>
      </Form>

      {message && <Alert variant="success" className="mt-3">{message}</Alert>}
      {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
    </div>
  )
}

SendInvitation.propTypes = {
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
}

export default SendInvitation
